import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var StudentMetrics = require("lib/data/StudentMetrics");

var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");

var GoalsTable = require("components/data/GoalsTable");
var RosterSelectors = require('lib/selectors/RosterSelectors');

var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var TruncatedDataNote = require("components/data/TruncatedDataNote");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "userIDs"
	);

	return conditions;
}

@connect(
	(state, props) => ({
		digests: DataSelectors.digests({ state, conditions: { userIDs: props.userIDs }}),
		students: RosterSelectors.students({ state, conditions: { ids: props.userIDs } }),
		loading: DataSelectors.isLoadingDigests({ state, key: 'index', userIDs: props.userIDs }),
		expectationMetrics: DataSelectors.expectationsMetrics({ state }),
	}),
	(dispatch, props) => ({
		populateData: () => {
			var query = {}
			
			var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
			if (!props.showGoals) {
				
				// This is a problem because it
				query.digest_embed = StudentMetrics.getDigestEmbeds(
					DataSelectors.dashboardOtherMetrics({})

				)
			}
			// TODO: standardize FE requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate")
				var actionFunction = DataActions.fetchDigests
				var options = { cache: true, query: query }
				return new Promise(function (resolve, reject) {          
					resolve($wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null));
				}).catch(() => console.log("Digests failed to load"))
			} else {
				return dispatch(DataActions.fetchDigests({
					conditions: propsToConditions(props),
					query: query,
					cache: true
				}))
			}
		}
	})
)
@providePopulateData()
class DataGoals extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { selectedTypeText: "Top 3" };
		if (!props.showGoals) {
			LuckyOrangeClient.tagComponent("OtherStatsTable");	
		} else {
			LuckyOrangeClient.tagComponent("GoalsTable");	
		}
		LuckyOrangeClient.tagComponent("DataGoals");
	}

	changeGoalSort(option) {
		this.setState({ selectedTypeText: option });
	}

	render() {
		var passProps = _.pick(this.props, "userIDs", "studentList", "showGoals", "showTotals", "studentLimit");
		if (this.props.studentLimit) {
			var goalsOptions = DropDownOptions.Button.simpleText({
				options: [TOP_VIEW, BOTTOM_VIEW, RECENT_VIEW],
				onClick: this.changeGoalSort
			});
			var sortTypeDropdown = (
				<ButtonDropdown text={ this.state.selectedTypeText } dropdownDisplay="link"
					className="goalsDropdown">
					{ goalsOptions }
				</ButtonDropdown>
			);
			
			if (this.state.selectedTypeText == TOP_VIEW) {
				var resultType = GoalsTable.TOP_RESULTS;
			} else if (this.state.selectedTypeText == BOTTOM_VIEW) {
				var resultType = GoalsTable.BOTTOM_RESULTS;
			} else if (this.state.selectedTypeText == RECENT_VIEW) {
				var resultType = GoalsTable.LAST_ACTIVE;
			}
		} else {
			if (!this.props.showFullData) {
				var resultType = GoalsTable.TOP_RESULTS;
				var truncatedRow = <TruncatedDataNote type={ GOALS } />
			}
		}

		var display = (
			<div className="dataGoals">
				{ sortTypeDropdown }
				<GoalsTable { ...passProps } reloadF={ this.props.populateData } digests={ this.props.digests }
					sortByResults={ resultType } showFullData={ this.props.showFullData } />
				{ truncatedRow }
			</div>
		)
		return (
			<div>
				{ display }
			</div>
		)
	}
}

var TOP_VIEW = "Top 3";
var BOTTOM_VIEW = "Bottom 3";
var RECENT_VIEW = "Recently Active";
var GOALS = "goals";

DataGoals.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showGoals: PropTypes.bool,
	showFullData: PropTypes.bool,
	showTotals: PropTypes.bool,
	studentLimit: PropTypes.number,
	expectationMetrics: PropTypes.array,
	students: PropTypes.array,
	studentList: PropTypes.string,

	// Data from @connect
	loading: PropTypes.bool,
	digests: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataGoals;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataGoals.js